import React, { useState } from 'react'
import { Button, Dropdown } from 'semantic-ui-react'
import { mentions } from './../../../config/mentions'

const Mention = ({ save, close }) => {
  const [name, setName] = useState('')

  const dropdownchangedHandler = (e, result) => {
    const { value } = result
    setName(value)
  }

  const mention = {
    username: '',
    value: '',
    uid: 'f6287c33-6e77-40cb-8a5d-66d62b4f38bb',
  }

  const onHandleSave = () => {
    save({
      ...mention,
      username: `${name}`,
      value: `${name}`
    })
  }

  const onHandleClose = () => {
    close()
  }

  return (
    <>
      <Dropdown
        label={{ icon: 'asterisk' }}
        labelPosition='right corner'
        placeholder=''
        style={{ width: '100%' }}
        onChange={dropdownchangedHandler}
        fluid
        selection
        options={mentions} />

      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}>

        <Button onClick={onHandleSave}>
          <i className="send circle right icon"></i> Invite
        </Button>

        <Button onClick={onHandleClose}>
          <i className="close icon"></i> Cancel
        </Button>
      </div>

    </>
  )
}

export default Mention
